import React from "react";

import PalamButtonBigRound from "../../../../generic/palam_button_big_round";

import { Icon } from "react-icons-kit";
import { move, settings, trash2 } from "react-icons-kit/feather/";

const HoverOverlay = props => {
  let {
    onStartMoveWidget,
    onDeleteWidget,
    onResizeWidget,
    onToggleWidgetSettings,
    reducedMode
  } = props;
  let widgetOverlayInnerClass = "widget-overlay-inner";
  let widgetOverlayClass = "widget-overlay";
  widgetOverlayInnerClass += reducedMode ? " reduced" : ""; 
  widgetOverlayClass += reducedMode ? " reduced" : ""; 

  return (
    <div className={widgetOverlayClass}>
      <div className={widgetOverlayInnerClass}>
        <PalamButtonBigRound
          size={40}
          onMouseDown={() => {
            onToggleWidgetSettings();
          }}
        >
          <Icon size={24} icon={settings} />
        </PalamButtonBigRound>
        <PalamButtonBigRound
          size={40}
          onMouseDown={evt => {
            onStartMoveWidget(evt);
          }}
        >
          <Icon size={24} icon={move} />
        </PalamButtonBigRound>
        <PalamButtonBigRound
          size={40}
          onMouseDown={() => {
            if (
              window.confirm("Are you sure you wish to delete this widget?")
            ) {
              onDeleteWidget();
            }
          }}
        >
          <Icon size={24} icon={trash2} />
        </PalamButtonBigRound>
      </div>

      <div
        className="widget-resizer widget-resizer-top"
        onMouseDown={() => {
          onResizeWidget("top");
        }}
      />
      <div
        className="widget-resizer widget-resizer-bottom"
        onMouseDown={() => {
          onResizeWidget("bottom");
        }}
      />
      <div
        className="widget-resizer widget-resizer-left"
        onMouseDown={() => {
          onResizeWidget("left");
        }}
      />
      <div
        className="widget-resizer widget-resizer-right"
        onMouseDown={() => {
          onResizeWidget("right");
        }}
      />
      <div
        className="widget-resizer widget-resizer-topleft"
        onMouseDown={() => {
          onResizeWidget("topleft");
        }}
      />
      <div
        className="widget-resizer widget-resizer-topright"
        onMouseDown={() => {
          onResizeWidget("topright");
        }}
      />
      <div
        className="widget-resizer widget-resizer-bottomleft"
        onMouseDown={() => {
          onResizeWidget("bottomleft");
        }}
      />
      <div
        className="widget-resizer widget-resizer-bottomright"
        onMouseDown={() => {
          onResizeWidget("bottomright");
        }}
      />
    </div>
  );
};

export default HoverOverlay;
